import { from } from 'rxjs';
import { filter, map, flatMap } from 'rxjs/operators';

const _clearEventData = {
    clearEventData: true,
};

/**
 * Predicate for existence of action type prop value in eventConfig
 * @param {object} eventConfig mapping of actions to events
 * @returns {(action: object) => boolean} if action structure is correct
 */
const _hasTracking = (eventConfig) => (action) => !!eventConfig[action.type];

/**
 * Finds value in eventConfig that matches given eventId key
 * @param {object} eventConfig mapping of actions to events
 * @returns {(eventId: string) => array} array of event objects
 */
const _getEventsFromMap = (eventConfig) => ({ type, payload }) =>
    Array.isArray(eventConfig[type])
        ? eventConfig[type].map((event) => ({ ...event, payload }))
        : [{ ...eventConfig[type], payload }];

/**
 * Take an observable of actions and return an observable of events
 * @param {Observable} action$ stream provided by redux observable
 * @returns {Observable} stream of event objects
 */
const createEventFilter = (trackingEventConfig) =>
    function filterEvents(action$) {
        return action$.pipe(
            filter(_hasTracking(trackingEventConfig)),
            map(_getEventsFromMap(trackingEventConfig)),
            flatMap((eventArr) => {
                const eventArray = [...eventArr, _clearEventData];

                return from(eventArray);
            }),
        );
    };

export default createEventFilter;
